module.exports = __webpack_public_path__ + "static/media/Safe-T25.08415808.jpg";